import { Injectable } from '@angular/core';
import {
  API_METHODS,
  API_URL,
  OperationType,
  ROUTE_PATH,
  USER_TYPE,
} from 'common/constants/sm-constants';
// import { SystemService } from "../core-services/system.service";
// import { FormDataService } from "./base-data-services/form-data.service";
// import { SmApiService } from "../core-services/sm-api.service";
import { environment } from 'src/environments/environment';
import { FeedbackModel } from 'common/models/page-models/feedback/feedback-data-model';
import { FormDataService } from '../../base-data-services/form-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { feedbackForm } from 'common/models/page-models/feedback/feedback-meta-model';
// import { resolve } from 'url';

@Injectable({
  providedIn: 'root',
})
export class FeedbackFormDataService extends FormDataService<FeedbackModel> {
  constructor(http: SmApiService, protected override  ss: SystemService) {
    super(API_URL.addFeedback, http, ss);
  }

  createInstance(): FeedbackModel {

    return new FeedbackModel();
  }

  getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.previewFeedback,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdatePayload(data) {
    let payload;
    payload = {
      id: data.id,
    };
    return payload;
  }


  // override modifyAPIResponse(response: any) {
  //   const feedback = response['detail'];
  //   return feedback;
  // }

  // override beforePostData(
  //   model: any,
  //   metamodel: any,
  //   dataModel: any
  // ): Promise<FeedbackModel> {
  //   return new Promise<any>((resolve, reject) => {
  //     const submitData: any = new feedbackForm();
  //     submitData.title = model.title;

  //     if (dataModel.id !== 0) {
  //       submitData.feedbackFormId = dataModel.id;
  //     }

  //     if (model.categories) {
  //       submitData.categorydata = model.categories.map(category => category.category);
  //     }

  //     model.questions = model.questions.filter(item => item.hasOwnProperty('question') && item.hasOwnProperty('questionType'));

  //     console.log(model)
  //     submitData.questions = model.questions.map((question, qIndex) => {
  //       const questionData: any = {
  //         question_text: question.question_text,
  //         question_type: Number(question.question_type),
  //         selected_category_text: question.selected_category_text
  //       };

  //       if (question.id !== '') {
  //         questionData.questionId = question.id;
  //       }

  //       if (question.options && question.options.length > 0) {
  //         questionData.options = question.options.map(option => option.option_text);
  //       }

  //       return questionData;
  //     });

  //     console.log(submitData, 'submitData');
  //     resolve(submitData);
  //   });
  // }


  // override modifyPostModel(formModel, dataModel) {
  //   console.log(formModel, dataModel);
  //   const submitData: any = new feedbackForm();
  //   submitData.id = formModel.id;
  //   submitData.title = formModel.title;
  //   if (formModel.categories) {
  //     submitData.categorydata = formModel.categories.map(category => category.category);
  //   }

  //   submitData.questions = formModel.questions.map((question, qIndex) => {
  //     const questionData: any = {
  //       question_text: question.question_text,
  //       question_type: Number(question.question_type),
  //       selected_category_text: question.selected_category_text
  //     };

  //     if (question.id !== '') {
  //       questionData.questionId = question.id;
  //     }

  //     if (question.options && question.options.length > 0) {
  //       questionData.options = question.options.map(option => option.option_text);
  //     }

  //     return questionData;
  //   });
  //   return submitData;
  // }

//Existing one befor Duplicate options Issue


  // override modifyPostModel(formModel, dataModel) {
  //   console.log("Form Model:", formModel); // Debugging step
  //   console.log("Data Model:", dataModel); // Debugging step
  
  //   const submitData: any = new feedbackForm();
  //   submitData.id = formModel.id;
  //   submitData.title = formModel.title;
  
  //   // Check for categories
  //   if (formModel.categories) {
  //     submitData.categorydata = formModel.categories.map(category => category.category);
  //   }
  
  //   // Check if questions are being modified correctly
  //   submitData.questions = formModel.questions.map((question, qIndex) => {
  //     const questionData: any = {
  //       question_text: question.question_text,
  //       question_type: Number(question.question_type),
  //       selected_category_text: question.selected_category_text
  //     };
  
  //     // Ensure question id is not empty before adding it
  //     if (question.id !== '') {
  //       questionData.questionId = question.id;
  //     }
  
  //     // Map the options if they exist
  //     if (question.options && question.options.length > 0) {
  //       questionData.options = question.options.map(option => option.option_text);
  //     }
  
  //     console.log("Question Data:", questionData); // Debugging step to track questions
  //     return questionData;
  //   });
  
  //   // Final debug to see the resulting data before returning
  //   console.log("Submit Data:", submitData);
  
  //   return submitData;
  // }
//   override modifyPostModel(formModel, dataModel) {
//     console.log("Form Model:", formModel); 
//     console.log("Data Model:", dataModel); 
  
//     const submitData: any = new feedbackForm();
//     submitData.id = formModel.id;
//     submitData.title = formModel.title;
  
//     if (formModel.categories) {
//         submitData.categorydata = formModel.categories.map(category => category.category);
//     }
  
//     submitData.questions = formModel.questions.map((question, qIndex) => {
//         const questionData: any = {
//             question_text: question.question_text,
//             question_type: Number(question.question_type),
//             selected_category_text: question.selected_category_text
//         };
  
//         if (question.id !== '') {
//             questionData.questionId = question.id;
//         }
  
//         if (question.options && question.options.length > 0) {
//             const optionTexts = question.options.map(option => option.option_text.trim());

//             const duplicateOptions = optionTexts.filter((text, index, array) => array.indexOf(text) !== index);
//             if (duplicateOptions.length > 0 && [6, 4, 1].includes(question.question_type)) { 
//                 this.ss.showError(`Question ${qIndex + 1}: Options cannot be the same! Duplicate options: ${duplicateOptions.join(', ')}`);
//                 throw new Error(`Duplicate options found in question ${qIndex + 1}`);
//             }

//             questionData.options = optionTexts;
//         }
  
//         // console.log("Question Data:", questionData); 
//         return questionData;
//     });
  
//     // console.log("Submit Data:", submitData);
  
//     return submitData;
// }

override modifyPostModel(formModel, dataModel) {
  // console.log("Form Model:", formModel); 
  // console.log("Data Model:", dataModel); 

  const submitData: any = new feedbackForm();
  submitData.id = formModel.id;
  submitData.title = formModel.title;

  if (formModel.categories) {
      submitData.categorydata = formModel.categories.map(category => category.category);
  }

  submitData.questions = formModel.questions.map((question, qIndex) => {
      const questionData: any = {
          question_text: question.question_text,
          question_type: Number(question.question_type),
          selected_category_text: question.selected_category_text
      };

      if (question.id !== '') {
          questionData.questionId = question.id;
      }

      if (question.options && question.options.length > 0) {
        const optionTexts = question.options.map(option => option.option_text.trim());
    
        const duplicateOptions = optionTexts.filter((text, index, array) => array.indexOf(text) !== index);
        if (duplicateOptions.length > 0 && [6, 1].includes(question.question_type)) {  
            this.ss.showError(`Question ${qIndex + 1}: Options cannot be the same! Duplicate options: ${duplicateOptions.join(', ')}`);
            throw new Error(`Duplicate options found in question ${qIndex + 1}`);
        }
    
        if ([6, 1].includes(question.question_type) && optionTexts.length < 2) {  
            this.ss.showError(`Question ${qIndex + 1}: At least 2 options are required for this question type.`);
            throw new Error(`Insufficient options for question ${qIndex + 1}`);
        }
    
        questionData.options = optionTexts;
    } else if ([6, 1].includes(question.question_type)) {  
        this.ss.showError(`Question ${qIndex + 1}: At least 2 options are required for this question type.`);
        throw new Error(`No options provided for question ${qIndex + 1}`);
    }
    

      // console.log("Question Data:", questionData); 
      return questionData;
  });

  // console.log("Submit Data:", submitData);

  return submitData;
}

  /*
  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<FeedbackModel> {
    return new Promise<any>((resolve, reject) => {
      const submitData: any = new feedbackForm();
      submitData.title = model.title;
      console.log('model', model, dataModel);


           submitData.feedbackFormId = dataModel.id;
      }
      if (model.categories) {
        model.categories.forEach((category, index) => {
          submitData[`categories[${index}]`] = category.category;
        });
      }

      model.questions = model.questions.filter(item => item.hasOwnProperty('question') && item.hasOwnProperty('questionType'));

      model.questions.forEach((question, qIndex) => {
        if (question.options === undefined) {
          question.options = [];
        }
        submitData[`questions[${qIndex}][question]`] = question.question;
        submitData[`questions[${qIndex}][questionType]`] = question.questionType;
        submitData[`questions[${qIndex}][selected_category]`] = question.selected_category;
        if (question.id !== '') {
          submitData[`questions[${qIndex}][questionId]`] = question.id;
        }

        if (question.options.length !== 0) {
          question.options.forEach((option, oIndex) => {

            if (option.id !== '') {
              submitData[`questions[${qIndex}][options][${oIndex}][optionId]`] = option.id;
              submitData[`questions[${qIndex}][options][${oIndex}][option_text]`] = option.option_text;
            } else if (dataModel.id !== 0) {
              submitData[`questions[${qIndex}][options][${oIndex}][optionId]`] = '';
              submitData[`questions[${qIndex}][options][${oIndex}][option_text]`] = option.option_text;
            } else {
              submitData[`questions[${qIndex}][options][${oIndex}]`] = option.option_text;
            }

          });
        }
      })
        ;
      console.log(submitData, 'submitData')
      // return;
      resolve(submitData);

    });
  }

  */

  override afterGetData(model: any): Promise<FeedbackModel> {
    return new Promise<FeedbackModel>((resolve, reject) => {
      // console.log('AFter Get Data', model);
      const newFeedBack = new FeedbackModel();
      newFeedBack.title = model.title;
      newFeedBack.id = model.id;
      newFeedBack.categories = model.categorydata;
      newFeedBack.questions = model.questions;


      resolve(newFeedBack)
    });

  }




  override updatepostUrl() {
    return environment.apiUrl + API_URL.EditFeedback
  }


  override getUpdateUrl() {
    return API_URL.EditFeedback;

  }
  override getOperationType(data: any) {

    if (data.feedbackFormId) {
      return OperationType.UPDATE
    } else {
      return OperationType.CREATE
    }
  }


}
